// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__Gn5uX","infoBtn":"quickbooks_infoBtn__1Qd5u","formBox":"quickbooks_formBox__E0cLQ","formFooter":"quickbooks_formFooter__1xrmu"};